import React from "react";
import { Box, Stack } from "digiwash-components";
import CustomIcon from "../../components/CustomIcon";

interface PageContainerShapeType {
  children?: React.ReactNode;
  bg?: string;
  p?: string;
  featured?: boolean;
  fullRadius?: boolean;
}

function PageContainerShape(props: PageContainerShapeType) {
  let { bg = "common.white", p = "l" } = props;
  return (
    <Box
      bg={bg}
      style={{
        borderTopLeftRadius: 30,
        borderTopRightRadius: 30,
        borderBottomLeftRadius: props.fullRadius ? 30 : 0,
        borderBottomRightRadius: props.fullRadius ? 30 : 0,
      }}
      p={p}
    >
      {props.featured ? (
        <Stack
          distribution="center"
          bg="common.white"
          style={{
            width: 24,
            height: 24,
            position: "absolute",
            top: -12,
            left: 16,
            zIndex: 1,
            borderRadius: 16,
          }}
        >
          <CustomIcon icon="featured" width={16} height={16} />
        </Stack>
      ) : null}
      {props.children}
    </Box>
  );
}

export default PageContainerShape;
